var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheck = function SvgCheck(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Check"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle\xE5\xA4\x87\xE4\xBB\xBD",
    width: 30,
    height: 30,
    rx: 15,
    fill: "#FFF28C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.2331C8 10.2331 11.1832 11.2455 15.7356 9.69208C20.288 8.13865 22.5 10.072 22.5 10.072V19.4984C22.5 19.4984 18.9201 18.1278 15.4912 19.4984C12.0623 20.869 8 19.4984 8 19.4984V10.2331Z",
    stroke: "#4F4400",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M14.9999 11.5V17.5",
    stroke: "#4F4400",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_2",
    d: "M16.5865 12.5C16.5865 12.5 15.14 12.5 14.4231 12.5C13.7062 12.5 13.125 12.9477 13.125 13.5C13.125 14.0523 13.7062 14.5 14.4231 14.5",
    stroke: "#4F4400",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_3",
    d: "M13.4135 16.5C13.4135 16.5 14.86 16.5 15.5769 16.5C16.2938 16.5 16.875 16.0523 16.875 15.5C16.875 14.9477 16.2938 14.5 15.5769 14.5H14.4231",
    stroke: "#4F4400",
    strokeWidth: 1.1,
    strokeLinecap: "round"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheck);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/check.3a130667.svg";